import React from "react";
import styled from "styled-components";

// components
import Text from "./Text";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
const MessageStyled = styled.div`
    display: flex;
    gap: ${convertPxToRem(6)};
    align-items: center;
`;
const CircleStyled = styled.div`
    background-color: ${colors.functional.secondary.lingo};
    width: ${convertPxToRem(8)};
    height: ${convertPxToRem(8)};
    border-radius: 50%;
`;

// component
const Message = ({ userMessage, onOpenModal }) => {
    const { headerMessage } = userMessage;
    return (
        <MessageStyled>
            <CircleStyled />
            <Text message={headerMessage} onOpenModal={onOpenModal} />
        </MessageStyled>
    );
};

export default Message;

import PropTypes from "prop-types";

// prop-types
Message.propTypes = {
    userMessage: PropTypes.object.isRequired,
    onOpenModal: PropTypes.func.isRequired
};
